import React from 'react';
import Flex from 'components/common/Flex';
import { Card, Col, Row } from 'react-bootstrap';
import barChart from 'assets/img/illustrations/crm-bar-chart.png';
import lineChart from 'assets/img/illustrations/crm-line-chart.png';
import PropTypes from 'prop-types';
// import { useSelector } from 'react-redux';

const IntestazioneAmbito = (props) => {
  const classeAmbitoEstesa =
    props.ambito.classe === `AMB`
      ? `AMBIENTE`
      : props.ambito.classe === `GOV`
      ? `GOVERNANCE`
      : `SOCIALE`;

  // const aziendaNome = useSelector((state) => state.questCorrente.aziendaNome);
  // <h6 className="text-primary fs-10 mb-0">{aziendaNome}</h6>

  return (
    <Card className="bg-100 shadow-none border mb-3">
      <Card.Body className="py-0">
        <Row className="g-0 justify-content-between">
          <Col sm="9">
            <Flex alignItems="center">
              <img src={barChart} width={90} alt="..." className="ms-n4" />
              <div>
                <h6 className="text-primary fs-10 mb-0">
                  {' '}
                  {classeAmbitoEstesa} - Tipologia: {props.ambito.tipologia}
                </h6>
                <h4 className="text-primary fw-bold mb-0">
                  {props.ambito.keyShow}
                  <span className="text-info fw-medium">
                    {' '}
                    {props.ambito.descrizione}
                  </span>
                </h4>
              </div>
              <img
                src={lineChart}
                width={140}
                alt="..."
                className="ms-n4 d-md-none d-lg-block"
              />
            </Flex>
          </Col>
          <Col md="auto" className="mb-3 mb-md-0">
            <Row className="g-3 gy-md-0 h-100 align-items-center">
              <Col xs="auto">
                <h6 className="text-700 mb-0 text-nowrap">
                  Codice Finanziario:{' '}
                  <strong>{props.ambito.codiceFinanziario}</strong>{' '}
                </h6>
                <h6 className="text-700 mb-0 text-nowrap">
                  Codice Impatto: <strong>{props.ambito.codiceImpatto}</strong>
                </h6>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

IntestazioneAmbito.propTypes = {
  ambito: PropTypes.object.isRequired
};

export default IntestazioneAmbito;
